import { BlockVariant, BlockView } from "../views/block/BlockView.view";

export const Base: React.SFC = ({children}) => <BlockView viewKey="padding.base" variant={BlockVariant.DEFAULT}>{children}</BlockView>;
export const Large: React.SFC = ({children}) => <BlockView viewKey="padding.large" variant={BlockVariant.DEFAULT}>{children}</BlockView>;
export const Small: React.SFC = ({children}) => <BlockView viewKey="padding.small" variant={BlockVariant.DEFAULT}>{children}</BlockView>;

const Padding = {
	Base: Base,
	Large: Base,
	Small: Small
}

export default Padding;




// WEBPACK FOOTER //
// ./src/common/fragments/Padding.tsx